import React from "react";
import { Mui } from "@osu/react-ui";
import { useApplicantDetailsState } from "../hooks/useApplicantDetailsState";

const CollegePrep = () => {
  const { data } = useApplicantDetailsState();
  const collegePrepUnits = data?.details.collegePrepUnits ?? {};

  // TODO Determine if this is still necessary
  // const hide = ["domestic-transfer", "international-transfer"].includes(collegePrepData?.group.key) && collegePrepData.earnedHoursPU >= 30;
  return (
    <Mui.Box>
      <Mui.Table>
        <Mui.TableHead>
          <Mui.TableRow>
            <Mui.TableCell                scope="col" tabindex="0">Units</Mui.TableCell>
            <Mui.TableCell align="center" scope="col" tabindex="0">Math</Mui.TableCell>
            <Mui.TableCell align="center" scope="col" tabindex="0">Natural Science</Mui.TableCell>
            <Mui.TableCell align="center" scope="col" tabindex="0">Foreign Language</Mui.TableCell>
          </Mui.TableRow>
        </Mui.TableHead>
        <Mui.TableBody>
          <Mui.TableRow>
            <Mui.TableCell component="th" role="rowheader" scope="row" tabindex="0">Minimum Required Units</Mui.TableCell>
            <Mui.TableCell align="center" role="gridcell" tabindex="0">{collegePrepUnits.minimumMath}</Mui.TableCell>
            <Mui.TableCell align="center" role="gridcell" tabindex="0">{collegePrepUnits.minimumNaturalScience}</Mui.TableCell>
            <Mui.TableCell align="center" role="gridcell" tabindex="0">{collegePrepUnits.minimumForeignLanguage}</Mui.TableCell>
          </Mui.TableRow>
          <Mui.TableRow>
            <Mui.TableCell component="th" role="rowheader" scope="row" tabindex="0">Earned Units</Mui.TableCell>
            <Mui.TableCell align="center" role="gridcell" tabindex="0">{collegePrepUnits.earnedMath}</Mui.TableCell>
            <Mui.TableCell align="center" role="gridcell" tabindex="0">{collegePrepUnits.earnedNaturalScience}</Mui.TableCell>
            <Mui.TableCell align="center" role="gridcell" tabindex="0">{collegePrepUnits.earnedForeignLanguage}</Mui.TableCell>
          </Mui.TableRow>
          <Mui.TableRow>
            <Mui.TableCell component="th" role="rowheader" scope="row" tabindex="0">Difference Between Minimum and Earned</Mui.TableCell>
            <Mui.TableCell align="center" role="gridcell" tabindex="0">{collegePrepUnits.differenceMath}</Mui.TableCell>
            <Mui.TableCell align="center" role="gridcell" tabindex="0">{collegePrepUnits.differenceNaturalScience}</Mui.TableCell>
            <Mui.TableCell align="center" role="gridcell" tabindex="0">{collegePrepUnits.differenceForeignLanguage}</Mui.TableCell>
          </Mui.TableRow>
        </Mui.TableBody>
      </Mui.Table>   
    </Mui.Box>
  );
};
export default CollegePrep;